<template>
  <!--  <template v-for="visitData in visitDataList" :key="visitData.info.id">-->
  <a-descriptions size="small" v-if="visitData && visitData.base_stat"></a-descriptions>
  <a-row :gutter="24" type="flex" v-if="visitData && visitData.base_stat">
    <a-col
      v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 12 }"
      style="padding-left: 3px; padding-right: 3px; margin-bottom: 6px"
      v-for="item in visitData.base_stat"
    >
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 16px 16px' }">
        <field :label="item.name" label-color="green" />
        <a-divider style="margin-bottom: 10px; margin-top: 5px" />
        <pane-item
          label_left=""
          size="large"
          :item_left_1="item.day_a"
          :item_left_2="item.day_b"
          :is_up="item.day_a.v >= item.day_c.v"
          icon="create"
          :item_center_1="item.day_c"
          :item_center_2="item.day_d"
        />
        <a-divider style="margin-bottom: 10px; margin-top: 10px" />
        <pane-item
          label_left="月"
          :item_left_1="item.month_a"
          :item_left_2="item.month_b"
          :is_up="item.month_a.v >= item.month_c.v"
          icon="arrow"
          :item_center_1="item.month_c"
          :item_center_2="item.month_d"
          label_right="增长率:"
          :item_right="item.month_e"
        />
        <pane-item
          style="margin-top: 5px"
          label_left="年"
          :item_left_1="item.year_a"
          :item_left_2="item.year_b"
          :is_up="item.year_a.v >= item.year_c.v"
          icon="arrow"
          :item_center_1="item.year_c"
          :item_center_2="item.year_d"
          label_right="增长率:"
          :item_right="item.year_e"
        />
      </a-card>
    </a-col>
    <!--    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 5 }" style="margin-bottom: 24px">-->
    <!--      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 8px 16px' }">-->
    <!--        <field label="收款目标" />-->
    <!--        <a-divider style="margin-bottom: 5px; margin-top: 5px" />-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          本月-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          {{ formatYuan(visitData.month_cz_price_target) }}-->
    <!--          <arrow-up-outlined style="color: crimson" v-if="visitData.month_cz_price_increase >= 0" />-->
    <!--          <arrow-down-outlined-->
    <!--            style="color: limegreen"-->
    <!--            v-if="visitData.month_cz_price_increase < 0"-->
    <!--          />-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          上年同期-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          {{ formatYuan(visitData.last_year_same_period.cz_price) }}-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          目标同比-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          {{ visitData.month_cz_price_increase }}%-->
    <!--          <caret-up-outlined style="color: crimson" v-if="visitData.month_cz_price_increase >= 0" />-->
    <!--          <caret-down-outlined-->
    <!--            style="color: limegreen"-->
    <!--            v-if="visitData.month_cz_price_increase < 0"-->
    <!--          />-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          本年累计-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          {{ formatYuan(visitData.year.cz_price) }}-->
    <!--        </a-card-grid>-->
    <!--      </a-card>-->
    <!--    </a-col>-->
    <!--    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 7 }" style="margin-bottom: 24px">-->
    <!--      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 8px 16px' }">-->
    <!--        <field label="耗单" />-->
    <!--        <a-divider style="margin-bottom: 5px; margin-top: 5px" />-->
    <!--        <field-big-->
    <!--          :label="`￥${numeral(visitData.today.used_price).format('0,0')}`"-->
    <!--          :value="`￥${numeral(visitData.yesterday.used_price).format('0,0')}`"-->
    <!--          :value1="visitData.today.used_price >= visitData.yesterday.used_price"-->
    <!--        />-->
    <!--        <field-big1-->
    <!--          :label="'本月：' + `￥${numeral(visitData.month.used_price).format('0,0')}`"-->
    <!--          :value="'上月：' + `￥${numeral(visitData.last_month.used_price).format('0,0')}`"-->
    <!--          :value1="visitData.month.used_price >= visitData.last_month.used_price"-->
    <!--        />-->
    <!--        <a-divider style="margin-bottom: 5px; margin-top: 5px" />-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        ></a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          <span style="font-size: 10px">今天</span>-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          <span style="font-size: 10px">昨天</span>-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          <span style="font-size: 10px">本月</span>-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          <span style="font-size: 10px">上月</span>-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          <span style="font-size: 10px">人数</span>-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          <span style="font-size: 10px">{{ visitData.today.used_customer }}</span>-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          <span style="font-size: 10px">{{ visitData.yesterday.used_customer }}</span>-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          <span style="font-size: 10px">{{ visitData.month.used_customer }}</span>-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 20%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          <span style="font-size: 10px">{{ visitData.last_month.used_customer }}</span>-->
    <!--        </a-card-grid>-->
    <!--      </a-card>-->
    <!--    </a-col>-->
    <!--    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 5 }" style="margin-bottom: 24px">-->
    <!--      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 8px 16px' }">-->
    <!--        <field label="耗单目标" />-->
    <!--        <a-divider style="margin-bottom: 5px; margin-top: 5px" />-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          本月-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          {{ formatYuan(visitData.month_used_price_target) }}-->
    <!--          <arrow-up-outlined-->
    <!--            style="color: crimson"-->
    <!--            v-if="visitData.month_used_price_increase >= 0"-->
    <!--          />-->
    <!--          <arrow-down-outlined-->
    <!--            style="color: limegreen"-->
    <!--            v-if="visitData.month_used_price_increase < 0"-->
    <!--          />-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          上年同期-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          {{ formatYuan(visitData.last_year_same_period.used_price) }}-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          目标同比-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          {{ visitData.month_used_price_increase }}%-->
    <!--          <caret-up-outlined-->
    <!--            style="color: crimson"-->
    <!--            v-if="visitData.month_used_price_increase >= 0"-->
    <!--          />-->
    <!--          <caret-down-outlined-->
    <!--            style="color: limegreen"-->
    <!--            v-if="visitData.month_used_price_increase < 0"-->
    <!--          />-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          本年累计-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="-->
    <!--            padding: 1px;-->
    <!--            min-width: 1px;-->
    <!--            height: 30px;-->
    <!--            width: 50%;-->
    <!--            vertical-align: middle;-->
    <!--            text-align: center;-->
    <!--          "-->
    <!--          :hoverable="false"-->
    <!--        >-->
    <!--          {{ formatYuan(visitData.year.used_price) }}-->
    <!--        </a-card-grid>-->
    <!--      </a-card>-->
    <!--    </a-col>-->
    <a-col
      v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }"
      style="padding-left: 3px; padding-right: 3px; margin-bottom: 6px"
      v-if="
        visitData &&
        visitData.order_used_record_stat &&
        visitData.order_used_record_stat.used_price_shop_type_distribution
      "
    >
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 0 16px' }">
        <field label="耗单总金额按板块划分" />
        <a-divider style="margin-bottom: 5px; margin-top: 5px" />

        <pie
          :height="200"
          :data="visitData.order_used_record_stat?.used_price_shop_type_distribution"
          :options="options"
          value-label="price"
        />
      </a-card>
    </a-col>
    <a-col
      v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }"
      style="padding-left: 3px; padding-right: 3px; margin-bottom: 6px"
      v-if="visitData && visitData.order_used_record_stat"
    >
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 50px 16px' }">
        <field label="客户耗单" />
        <a-divider style="margin-bottom: 5px; margin-top: 5px" />
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          项目人头
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.order_used_record_stat?.project_person_count }}
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          项目数量
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.order_used_record_stat?.project_count }}
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          项目金额
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ formatYuan(visitData.order_used_record_stat?.project_money) }}
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          产品人头
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.order_used_record_stat?.product_person_count }}人
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          产品金额
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ formatYuan(visitData.order_used_record_stat?.product_count) }}
        </a-card-grid>
      </a-card>
    </a-col>

    <a-col
      v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }"
      style="padding-left: 3px; padding-right: 3px; margin-bottom: 6px"
      v-if="
        visitData &&
        visitData.order_used_record_stat &&
        visitData.order_used_record_stat.used_price_grade_distribution
      "
    >
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 0 16px' }">
        <field label="耗单总金额按等级划分" />
        <a-divider style="margin-bottom: 5px; margin-top: 5px" />
        <pie
          :height="200"
          :data="visitData.order_used_record_stat?.used_price_grade_distribution"
          :options="options"
          value-label="price"
        />
      </a-card>
    </a-col>
    <a-col
      v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }"
      style="padding-left: 3px; padding-right: 3px; margin-bottom: 6px"
      v-if="visitData && visitData.used_rate"
    >
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 80px 16px' }">
        <field label="实时利用率" />
        <a-divider style="margin-bottom: 5px; margin-top: 5px" />
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 55%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          床位利用率
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 45%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.used_rate?.bed_rate }}
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 55%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          医生利用率
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 45%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.used_rate?.yi_sheng_rate }}
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 55%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          治疗师利用率
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 45%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.used_rate?.mei_liao_shi_rate }}%
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 55%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          营养师利用率
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 45%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.used_rate?.ying_yang_shi_rate }}%
        </a-card-grid>
      </a-card>
    </a-col>

    <a-col
      v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }"
      style="padding-left: 3px; padding-right: 3px; margin-bottom: 6px"
      v-if="
        visitData &&
        visitData.detail_info &&
        visitData.detail_info.right_stat &&
        visitData.detail_info.right_stat.right_shop_type_distribution
      "
    >
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 0 16px' }">
        <field label="权益按板块划分" />
        <a-divider style="margin-bottom: 5px; margin-top: 5px" />
        <pie
          :height="200"
          :data="visitData.detail_info?.right_stat?.right_shop_type_distribution"
          :options="options"
          value-label="price"
        />
      </a-card>
    </a-col>
    <a-col
      v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }"
      style="padding-left: 3px; padding-right: 3px; margin-bottom: 6px"
      v-if="visitData && visitData.detail_info && visitData.detail_info.right_stat"
    >
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 50px 16px' }">
        <field label="客户权益" />
        <a-divider style="margin-bottom: 5px; margin-top: 5px" />
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          权益金余额
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ formatYuan(visitData.detail_info.right_stat?.cz_price) }}
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          返利余额
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ formatYuan(visitData.detail_info.right_stat?.fl_price) }}
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          返利率
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.detail_info.right_stat?.fl_rate }}%
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          余项客户
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.detail_info.right_stat?.customer_count }}人
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          当前客户
        </a-card-grid>
        <a-card-grid
          style="
            padding: 1px;
            min-width: 1px;
            height: 30px;
            width: 50%;
            vertical-align: middle;
            text-align: center;
          "
          :hoverable="false"
        >
          {{ visitData.detail_info.right_stat?.right_customer_count }}人
        </a-card-grid>
      </a-card>
    </a-col>

    <a-col
      v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }"
      style="padding-left: 3px; padding-right: 3px; margin-bottom: 6px"
      v-if="
        visitData &&
        visitData.detail_info &&
        visitData.detail_info.right_stat &&
        visitData.detail_info.right_stat.right_grade_distribution
      "
    >
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 0 16px' }">
        <field label="权益按等级划分" />
        <a-divider style="margin-bottom: 5px; margin-top: 5px" />
        <pie
          :height="200"
          :data="visitData.detail_info?.right_stat?.right_grade_distribution"
          :options="options"
          value-label="price"
        />
      </a-card>
    </a-col>
    <!--    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 5 }" style="margin-bottom: 24px" v-if='visitData && visitData.used_rate'>-->
    <!--      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 36px 16px' }">-->
    <!--        <field label="详细信息" />-->
    <!--        <a-divider style="margin-bottom: 5px; margin-top: 5px" />-->
    <!--        <a-card-grid-->
    <!--          style="padding: 1px;min-width: 1px;height: 30px;width: 50%;vertical-align: middle; text-align: center;"-->
    <!--          :hoverable="false">-->
    <!--          余值-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="padding: 1px;min-width: 1px;height: 30px;width: 50%;vertical-align: middle; text-align: center;"-->
    <!--          :hoverable="false">-->
    <!--          {{ visitData.detail_info?.remain_money }}-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style=" padding: 1px;min-width: 1px;height: 30px;width: 50%;vertical-align: middle;text-align: center;"-->
    <!--          :hoverable="false">-->
    <!--          余客-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="padding: 1px;min-width: 1px;height: 30px;width: 50%;vertical-align: middle;text-align: center;"-->
    <!--          :hoverable="false">-->
    <!--          {{ visitData.detail_info?.remain_customer }}-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="padding: 1px;min-width: 1px;height: 30px;width: 50%;vertical-align: middle;text-align: center;"-->
    <!--          :hoverable="false">-->
    <!--          充值返利率-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style=" padding: 1px;min-width: 1px;height: 30px; width: 50%;vertical-align: middle; text-align: center;"-->
    <!--          :hoverable="false">-->
    <!--          {{ visitData.detail_info?.cz_fl_rate }}%-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style="padding: 1px; min-width: 1px;height: 30px; width: 50%; vertical-align: middle; text-align: center;"-->
    <!--          :hoverable="false">-->
    <!--          下单返利率-->
    <!--        </a-card-grid>-->
    <!--        <a-card-grid-->
    <!--          style=" padding: 1px;min-width: 1px;height: 30px;width: 50%; vertical-align: middle;text-align: center;"-->
    <!--          :hoverable="false">-->
    <!--          {{ visitData.detail_info?.order_fl_rate }}%-->
    <!--        </a-card-grid>-->
    <!--      </a-card>-->
    <!--    </a-col>-->
    <a-col
      v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }"
      style="padding-left: 3px; padding-right: 3px; margin-bottom: 6px"
      v-if="
        visitData &&
        visitData.detail_info &&
        visitData.detail_info &&
        visitData.detail_info?.customer_distribution
      "
    >
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '12px 16px 0 16px' }">
        <field label="当前有效客户构成" />
        <a-divider style="margin-bottom: 5px; margin-top: 5px" />
        <pie :height="200" :data="visitData.detail_info?.customer_distribution" />
      </a-card>
    </a-col>
  </a-row>

  <!--  </template>-->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Field, PaneItem } from './charts';
import numeral from 'numeral';
// import FieldBig1 from '@/views/dashboard/analysis/components/charts/field-big1/index.vue';
// import FieldBig from '@/views/dashboard/analysis/components/charts/field-big/index.vue';
import {
  CaretUpOutlined,
  CaretDownOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from '@ant-design/icons-vue';
import { Pie } from './charts';

export default defineComponent({
  name: 'AreaDeskTop',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    visitData: {
      type: [Array, Object],
      required: true,
    },
  },
  setup() {
    const formatYuan = (val: string | number) => `¥ ${numeral(val).format('0,0')}`;
    const options = {
      tooltip_formatter: (param: any) => {
        return [
          '金额: ' + param.data.v.price + `<hr size=1 style='margin: 3px 0'>`,
          '返利率: ' + param.data.v.fl_rate + '<br/>',
        ].join('');
      },
    };

    return {
      numeral,
      formatYuan,
      options,
    };
  },
  components: {
    Field,
    PaneItem,
    // FieldBig1,
    // FieldBig,
    ArrowUpOutlined,
    ArrowDownOutlined,
    CaretUpOutlined,
    CaretDownOutlined,
    Pie,
  },
});
</script>
<style lang="less" scoped>
@import './index.less';
</style>
